export { IStyleFunction } from '@uifabric/merge-styles';
